/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, Input, OnInit, OnChanges} from '@angular/core';
import {ServerObjectService} from "../../services/server-object.service";
import {ServiceService} from "../../services/service.service";
import {NgxSpinnerService} from "ngx-spinner";

declare var $: any;

@Component({
  selector: 'app-settings-session',
  templateUrl: './settings.session.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsSessionComponent implements OnInit, OnChanges {
  @Input() session;
  serverObjectInstance = null;
  timeout_in_minutes: number;
  prepare_time_in_minutes: number;
  show_notification: boolean;
  auto_update_session: boolean;

  constructor(private services: ServiceService, private serverObjectService: ServerObjectService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {

  }

  ngOnChanges(): void {
    if (this.session) {
      console.log("session id is " + this.session.id);

      this.serverObjectService.getServerObjectInstanceById(this.session.id).then(response => {
          this.serverObjectInstance = response;
          this.setSessionSettings();
        },
        error => {
          console.log("Could not get session instance: " + error);
        });
    }
  }

  private setSessionSettings(): void {
    this.timeout_in_minutes = this.serverObjectInstance.data.find( a => a.property.property == "timeout_in_minutes").value;
    this.prepare_time_in_minutes = this.serverObjectInstance.data.find( a => a.property.property == "prepare_time_in_minutes").value;
  }

  public async updateSettingsSession(): Promise<void> {
    this.spinner.show();

    this.serverObjectInstance.data.find( a => a.property.property == "timeout_in_minutes").value = this.timeout_in_minutes;
    this.serverObjectInstance.data.find( a => a.property.property == "timeout_in_minutes").object_value = this.timeout_in_minutes;

    this.serverObjectInstance.data.find( a => a.property.property == "prepare_time_in_minutes").value = this.prepare_time_in_minutes;
    this.serverObjectInstance.data.find( a => a.property.property == "prepare_time_in_minutes").object_value = this.prepare_time_in_minutes;

    try {
      await this.serverObjectService.updateServerObjectInstance(this.serverObjectInstance);
    } catch (error) {
      console.log("Error updating SettingsSession Instance: " + error);
      const response: Response = error;
      alert(response.text());
    }
    this.spinner.hide();
  }

  showNotificationClicked(): void {
    this.show_notification = $("#show_notification")[0].checked;
  }

  autoUpdateSessionClicked(): void {
    this.auto_update_session = $("#auto_update_session")[0].checked;
  }
}
